import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import CustomizePanel from './CustomizePanel';
import { t } from '../../utilities/translator';
import { pushEvent } from '../../utilities/analytics';
import { CUSTOMIZE_BUTTON_CLICKED } from '../../constants/analyticEvents';
import ErrorBoundary from '../../components/ErrorBoundary';
import { isMobile } from '../../utilities/helpers';
import { toggleCustomize } from './customizeButtonSlice';
import { selectDealsListPending } from '../dealsList/dealsListSlice';
import { selectFilterData } from '../mainFilter/selectors';
import { getParamFromUrl } from '../../utilities/urlResolver';

const CustomizeButton = () => {
  const dispatch = useDispatch();
  const { show } = useSelector(state => state.customize);
  const { showResults } = useSelector(state => state.app);
  const dealListPending = useSelector(selectDealsListPending);
  const isMobileView = isMobile();
  const { searchEngine } = useSelector(selectFilterData);
  const { fromwhere } = searchEngine;

  const userContext = JSON.parse(localStorage.getItem('hf_user')); // useSelector(selectUser);
  const originNotSet = !((userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth && userContext?.user?.originAirports?.length) || localStorage.getItem('selectedFromwhere') || sessionStorage.getItem('fromWhereOpened'));

  const handleCustomizeButtonClick = () => {
    dispatch(toggleCustomize(true));
    pushEvent(CUSTOMIZE_BUTTON_CLICKED);
  }

  useEffect(() => {
    if (isMobileView && !dealListPending && getParamFromUrl('openFilter') && getParamFromUrl('openFilter') === 'who') {
      dispatch(toggleCustomize(true));
    }
  }, [dispatch, isMobileView, dealListPending]);

  const handleLikeClick = () => {
    const userContext = JSON.parse(localStorage.getItem('hf_user'));
    if (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) {
      window.open('/holidayfinder/favorites', '_blank')
    } else if (typeof openLoginModal !== 'undefined') {
      // eslint-disable-next-line no-undef
      openLoginModal("Favorites on card");
    } else {
      window.jQuery('#loginModal').modal('show');
    }
  };

  const customizeButtonClassNames = cn('customize-button py-4 gap-2 leading-none !font-semibold rounded-full button-visible');

  return (
    <>
      <div className="fixed-bottom-action-bar">
        <div className="p-2 invisible"><i className="ri-discount-percent-line text-2xl" /></div>
        {showResults ? (
          <button className={customizeButtonClassNames} onClick={handleCustomizeButtonClick}>
            <i className="ri-bard-line text-xl leading-none" />
            <span className="customize-btn-label">{t('customize.showBtn')}</span>
          </button>
        ) : (
          <button className="px-5 py-4 mb-5 w-full flex justify-start gap-2 border-none bg-white rounded-xl" onClick={handleCustomizeButtonClick}>
            <i className="ri-bard-line" />
            {t('customize.showBtnInitial')}
          </button>
        )}
        <div className="p-2" onClick={handleLikeClick}><i className="ri-heart-3-line text-2xl" /></div>
      </div>
      <ErrorBoundary>
        <CustomizePanel show={show} close={() => dispatch(toggleCustomize(false))} />
      </ErrorBoundary>
    </>
  )
}

export default CustomizeButton
